module.exports = __webpack_public_path__ + "assets/e26f5d098b1f212be5d5e00e7b215559.json";